import type { ReviewCycleDetail } from "#shared/reviewCycleSchemas.ts";
import { Button } from "@/components/ui/button.tsx";
import { Tooltip, TooltipContent } from "@/components/ui/tooltip.tsx";
import { PaperAirplaneIcon } from "@heroicons/react/20/solid";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { reviewCyclesI18NextInstanceKey } from "../../../i18n/i18next.ts";
import { CycleNudgeDialog } from "./CycleNudgeDialog.tsx";

export interface CycleNudgeButtonProps {
    cycle: ReviewCycleDetail;
}

export function CycleNudgeButton({ cycle }: CycleNudgeButtonProps) {
    const i18nextInstance = useI18nextInstance(reviewCyclesI18NextInstanceKey);
    const { t } = useTranslation("CycleNudgeButton", { i18n: i18nextInstance });
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = useCallback(() => setIsOpen(true), []);

    const unavailableReason = cycle.state === "draft" ? t("unavailable.draft") : cycle.state === "locked" ? t("unavailable.locked") : undefined;

    if (unavailableReason) {
        return (
            <Tooltip delay={0}>
                <Button intent="outline" aria-disabled="true" className="shrink-0 cursor-not-allowed opacity-50">
                    <PaperAirplaneIcon aria-hidden="true" />
                    {t("label")}
                </Button>
                <TooltipContent>{unavailableReason}</TooltipContent>
            </Tooltip>
        );
    }

    return (
        <>
            <Button intent="outline" className="shrink-0" onPress={handleOpen}>
                <PaperAirplaneIcon aria-hidden="true" />
                {t("label")}
            </Button>
            <CycleNudgeDialog cycle={cycle} isOpen={isOpen} onOpenChange={setIsOpen} />
        </>
    );
}
